export default {
      id: "icon-oclock-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-oclock",
      toString: function () {
        return this.url;
      }
    }